import { render, staticRenderFns } from "./select-identification-type.vue?vue&type=template&id=2b679909"
import script from "./select-identification-type.vue?vue&type=script&lang=js"
export * from "./select-identification-type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports